// Simple global registry for an "unsaved changes" guard.
let current = null;

export function registerGuard({ isDirty, showPrompt }) {
    current = { isDirty, showPrompt };
    return () => {
        if (current && current.isDirty === isDirty && current.showPrompt === showPrompt) current = null;
    };
}

export function getGuard() {
    return current;
}

export default { registerGuard, getGuard };
